"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = void 0;
/**
 * Formats a given phone number string by removing any non-digit characters and applying a standard U.S. format.
 * - If the input is falsy, it's returned as is.
 * - If the cleaned phone number has less than 4 digits, it's returned as is.
 * - If the cleaned phone number has between 4 and 6 digits, it's formatted as `(XXX) XXX`.
 * - If the cleaned phone number has 7 or more digits, it's formatted as `(XXX) XXX - XXXX`.
 *
 * @param input - The phone number string, possibly containing non-digit characters.
 * @returns The formatted phone number string.
 */
const formatPhoneNumber = (input) => {
    if (!input)
        return input;
    const phoneNumber = input.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4)
        return phoneNumber;
    if (phoneNumberLength < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)} - ${phoneNumber.slice(6, 10)}`;
};
exports.formatPhoneNumber = formatPhoneNumber;
